import { gql } from "@apollo/client";

export const GET_PACIENTES_VISITA = gql`
query getPacientesVisita($idDelegacion: Int!) {
    pacientesVisita(idDelegacion: $idDelegacion) {
        idPaciente
        nombre
        apellido
        numeroDocumento
    }
}`;

const adaptPaciente = (paciente) => {
  const { idPaciente, nombre, apellido, numeroDocumento } = paciente;

  return {
    id: idPaciente,
    label: `${apellido}, ${nombre} - HC: ${idPaciente}`,
    nombre: nombre,
    apellido: apellido,
    numeroDocumento: numeroDocumento,
  };
};

export const adaptPacientes = (data) => {
  const adaptedData = data?.pacientesVisita?.map((paciente) => adaptPaciente(paciente));

  return adaptedData;
};